export const COLORS = {
    FDI_YELLOW: "#f8c30f",
};
